class Monitoring.Views.SocialContentViewFactory

  initialize: ->

  @create: (socialContent, allTags, currentUser, accountSettings, customerData, defaultChartsByAccount) ->
    data = if _.isString(socialContent.data) then $.parseJSON(socialContent.data) else socialContent.data
    socialContent.data = data
    viewConstructor = undefined
    model = new Monitoring.Models.SocialContents.AnalysisUnitFactory().create(socialContent, allTags)
    if (data.type == 'instagramMedia' or data.type == 'instagramComment') and socialContent.group_type == 'instagramapi'
      viewConstructor = Monitoring.Views.SocialContents.InstagramContentView
    else
      data.interaction ||= {}
      if data.type == 'twitter'
        if data.subType == 'direct-message'
          viewConstructor = Monitoring.Views.SocialContents.TwitterDirectMessageContentView
        else
          viewConstructor = Monitoring.Views.SocialContents.TwitterContentView
      else if data.type == 'facebook'
        viewConstructor = Monitoring.Views.SocialContents.FacebookContentView
      else if data.type == 'google_play'
        viewConstructor = Monitoring.Views.SocialContents.ReviewCommentView
      else if data.type == 'apple_app_store'
        viewConstructor = Monitoring.Views.SocialContents.AppleStore.ReviewCommentView
      else if data.type == 'review-comment' || data.type == 'google_play'
        viewConstructor = Monitoring.Views.SocialContents.ReviewCommentView
      else if data.type == 'webchat'
        viewConstructor = Monitoring.Views.SocialContents.WebchatContentView
      else if data.type == 'cem_survey_response'
        viewConstructor = Monitoring.Views.SocialContents.CemSurveyResponseContentView
      else if data.type == 'image'
        #TODO: Check when the image content is defined
        viewConstructor = Monitoring.Views.SocialContents.ImageContentView
      else if data.type == 'whatsapp'
        viewConstructor = Monitoring.Views.SocialContents.WhatsappMessageContentView
      else if (data.type == 'youtube' && data.sub_type == 'yt-video')
        viewConstructor = Monitoring.Views.SocialContents.YoutubeVideoContentView
      else if data.type == 'linkedin'
        viewConstructor = Monitoring.Views.SocialContents.LinkedIn.LinkedInContentView
      else if data.sub_type == 'instagram_business_discovery_listening_media' || data.origin == 'instagram_business_discovery_api'
        viewConstructor = Monitoring.Views.SocialContents.InstagramBusinessListening.InstagramBusinessListeningContentView
      else if data.type == 'email'
        viewConstructor = Monitoring.Views.SocialContents.EmailContentView
      else if data.type == Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessContent.TYPE
        viewConstructor = Monitoring.Views.SocialContents.GoogleMyBusinessContentView
      else if data.sub_type == 'ig-message' && data.origin == 'instagram-message-api'
        viewConstructor = new Monitoring.Views.InstagramMessageContentViewFactory().create(model)
      else if data.type == 'tiktok'
        viewConstructor = new Monitoring.Views.SocialContents.SocialContentView().create(model)
    # Use InboxContent by default...
    unless viewConstructor
      viewConstructor = Monitoring.Views.SocialContents.InboxContentView
    new viewConstructor { model, currentUser, accountSettings, customerData, defaultChartsByAccount }
